// extracted by mini-css-extract-plugin
export default {"c4Box":"C4_c4Box__Lx18x","textBox":"C4_textBox__A5ttT"};